import classNames from "classnames";
import {ReactNode} from "react";

import {Card} from "@/components/card/Card.tsx";
import {Checkbox} from "@/components/checkbox/Checkbox.tsx";

import styles from "./OnboardingCard.module.scss";

interface OnboardingCardProps {
  header?: ReactNode;
  body: ReactNode;
  checked: boolean;
  setChecked: (checked: boolean) => void;
  checkDisabled?: boolean;
  active?: boolean;
  label?: string;
  checkboxInHeader?: boolean;
}

export const OnboardingCard = ({
  header,
  body,
  checked,
  setChecked,
  checkDisabled,
  active,
  label,
  checkboxInHeader,
}: OnboardingCardProps) => {
  return (
    <Card active={active}>
      <div className={styles.onboardingCard}>
        <div className="w-100">
          {header && (
            <div className={classNames(styles.onboardingCardHeader, "pulseTextH2Bold")}>
              {header}
              {checkboxInHeader && (
                <Checkbox
                  className={classNames(styles.onboardingCardCheckbox, {"d-md-none ms-auto": checkboxInHeader})}
                  checked={checked}
                  onChange={({target}) => setChecked(target.checked)}
                  id={label || "onboarding-card-checkbox"}
                  disabled={checkDisabled}
                />
              )}
            </div>
          )}
          {body}
        </div>
        <Checkbox
          className={classNames(styles.onboardingCardCheckbox, {"d-none d-md-block": checkboxInHeader})}
          checked={checked}
          onChange={({target}) => setChecked(target.checked)}
          id={label || "onboarding-card-checkbox"}
          disabled={checkDisabled}
        />
      </div>
    </Card>
  );
};
